import { motion } from 'framer-motion';

export const PageWrapper = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{
      duration: 0.35,
      ease: [0.25, 0.1, 0.25, 1], // smoother easing (similar to "ease")
    }}
  >
    {children}
  </motion.div>
);
